import Backend from 'App/Dataman-Backend';

const {
  apiUrlFavoriteFeatureOptions,
  apiUrlFavoriteUserCountries,
  apiUrlFavoriteUserTypes,
  apiUrlFavoriteUserNiceClasses,
} = Backend.config;

export const FAVORITES_PATHS = {
  featureOptions: apiUrlFavoriteFeatureOptions,
  countries: apiUrlFavoriteUserCountries,
  types: apiUrlFavoriteUserTypes,
  niceClasses: apiUrlFavoriteUserNiceClasses,
};
